/**
 * Construye el enlace de WhatsApp.
 *
 * @param {Object} options
 * @param {string} options.phone Número telefónico con o sin formato.
 * @param {string} [options.text] Mensaje a enviar.
 * @param {boolean} [options.useWaMe=true] Usa wa.me o api.whatsapp.com.
 * @returns {string}
 */
export const buildWhatsAppLink = ({ phone, text = "", useWaMe = true }) => {
  const digits = phone.replace(/\D/g, "");

  if (!digits) return "";

  const message = encodeURIComponent(text);

  if (useWaMe) {
    return `https://wa.me/${digits}${message ? `?text=${message}` : ""}`;
  }

  return `https://api.whatsapp.com/send?phone=${digits}${
    message ? `&text=${message}` : ""
  }`;
};

/**
 * Abre WhatsApp en una nueva pestaña.
 *
 * @param {string} phone
 * @param {string} text
 * @param {boolean} useWaMe
 */
export const openWhatsApp = (phone, text = "", useWaMe = true) => {
  const url = buildWhatsAppLink({
    phone,
    text,
    useWaMe,
  });

  if (!url) return;

  window.open(url, "_blank", "noopener,noreferrer");
};
